import { Component } from "@angular/core";
import { IAppState } from "@app/store/app.reducer";
import { LiveChatToggle } from "@app/store/support";
import { Store } from "@ngrx/store";
import { LiveChatService } from "../live-chat.service";

@Component({
	selector: "c4-live-chat-button",
	templateUrl: "./live-chat-button.component.html",
	styleUrls: ["./live-chat-button.component.scss"]
})
export class LiveChatButtonComponent {

	constructor(private store: Store<IAppState>, private liveChatService: LiveChatService) { }
	chatEnabled$ = this.liveChatService.chatEnabled$;
	
	toggleChat(): void {
		this.store.dispatch(new LiveChatToggle());
	}
}
